import { useContext } from 'react';

import ContemporaryContext from 'contexts/ContemporaryContext';

// ==============================|| HOOKS - AUTH ||============================== //

const useContemp = () => {
  const context = useContext(ContemporaryContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
};

export default useContemp;
